import { createFileRoute } from "@tanstack/react-router";

import TodosUploads from "@/features/todos/todos-uploads";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/ausgang/uploads",
)({
  component: ReceivableUploadsPage,
  staticData: {
    breadcrumb: ["todos.receivable.title"],
  },
});

function ReceivableUploadsPage() {
  return <TodosUploads type="receivable" />;
}
